import { isExpired } from "react-jwt";
import { LocalStorageService } from "./local-storage.service";
import { SessionService } from "./session.service";
import { refreshToken } from "../../pages/auth/authSlice";
import { ROLE_ID_BY_ROLE_NAME } from "../../pages/auth/userRoles.enum";
import axios from "axios";
const { REACT_APP_BASE_URL } = process.env;
// import { useDispatch } from "react-redux";

//will be removed after test
// const testToken = "";
// const dispatch = useDispatch();

const AuthService = {
   getAccessToken() {
      return LocalStorageService.getItem("atoken") || null; // will be null after test
   },

   getRefreshToken() {
      return LocalStorageService.getItem("rtoken") || null; // will be null after test;
   },

   getFullName() {
      return localStorage.getItem("fullName") || null;
   },

   setTokens(aToken, rToken) {
      LocalStorageService.setItem("atoken", aToken);
      LocalStorageService.setItem("rtoken", rToken);
   },

   async refreshToken() {
      const refreshToken = this.getRefreshToken();

      if(!refreshToken) {
         throw new Error('Refresh token does not exist!');
      }

      const refreshPayload = {
         refreshToken: refreshToken
      }

      const response = await axios.post(`${REACT_APP_BASE_URL}/Accounts/refresh-token`, refreshPayload);
      if (response.data.success) {
         // Assuming the response contains the new tokens
         //  const { accessToken, refreshToken } = response.data;
         return response.data;
      } else {
         throw new Error("Failed to refresh token");
      }

      // try {
      //    const response = await axios.post(`${REACT_APP_BASE_URL}/Accounts/refresh-token`, {
      //       refreshToken: refreshToken
      //    });

      //    if (response.data.success) {
      //       // Assuming the response contains the new tokens
      //       //  const { accessToken, refreshToken } = response.data;
      //       return response.data;
      //    } else {
      //       throw new Error("Failed to refresh token");
      //    }
      // } catch (error) {
      //    console.error("Error refreshing token:", error);
      //    throw error;
      // }
   },

   isTokenExpired() {
      const token = this.getAccessToken();

      if (token === null || token === "") {
         return true;
      } else {
         return isExpired(token);
      }
   },

   isAuthenticated() {
      const token = this.getAccessToken();

      // if(LocalStorageService.getItem('atoken') && LocalStorageService.getItem('rtoken') && isExpired(token)) {
      //    dispatch(refreshToken(LocalStorageService.getItem('rtoken')));
      // }

      // return !isExpired(token);
      return !!token
   },

   // Every role the account holds. An account can hold more than one (e.g. both
   // Expert and Approver) - only one of them is active per session.
   getRoles() {
      const user = AuthService.getUser();
      return user?.roles || [];
   },

   // The single role the current token actually authorizes. The token is
   // encrypted, so this is read from the login/refresh/switch-role response body
   // we stored, never decoded from the token itself.
   getActiveRoleName() {
      const user = AuthService.getUser();
      return user?.activeRole || null;
   },

   hasMultipleRoles() {
      return AuthService.getRoles().length > 1;
   },

   // Role ids the session may act under - exactly one, the active role. Sessions
   // stored before the backend started sending ActiveRole have none to key off,
   // so those fall back to every role on the account, as authorization behaved
   // before.
   getActiveRoleIds() {
      const roles = AuthService.getRoles();
      const allRoleIds = roles.map((role) => role?.id).filter(Boolean);
      const activeRoleName = AuthService.getActiveRoleName();

      if (!activeRoleName) {
         return allRoleIds;
      }

      const activeRole = roles.find((role) => role?.name === activeRoleName);
      const activeRoleId = activeRole?.id || ROLE_ID_BY_ROLE_NAME[activeRoleName];

      return activeRoleId ? [activeRoleId] : allRoleIds;
   },

   isAuthorized(allowedRoles) {
      const user = AuthService.getUser();

      const userRoles = user !== null ? AuthService.getActiveRoleIds() : ["-1"];

      const contains = allowedRoles.some((element) => {
         return userRoles?.indexOf(element) !== -1;
      });
      return contains;
   },

   setUser(model) {
      LocalStorageService.setItem("user", model);
   },

   // Stores a whole login / refresh-token / switch-role payload at once - they
   // all return the same Data shape, and all three have to leave the stored
   // user, activeRole and token pair consistent with each other.
   setSession(model) {
      if (!model) return;
      AuthService.setUser(model);
      AuthService.setFullName(model.fullName);
      AuthService.setTokens(model.token, model.refreshToken);
   },

   setFullName(name) {
      localStorage.setItem("fullName", name);
   },

   setUserName(name) {
      const user = LocalStorageService.getItem("user");
      user.fullName = name;
      LocalStorageService.setItem("user", user);
   },

   getUser() {
      if (this.isAuthenticated()) {
         return LocalStorageService.getItem("user");
      } else {
         return null;
      }
   },

   logout() {
      LocalStorageService.removeItem("user");
      LocalStorageService.removeItem("atoken");
      LocalStorageService.removeItem("rtoken");
      LocalStorageService.removeItem("orgId");
      LocalStorageService.removeItem("workspaceID");
      LocalStorageService.removeItem("currentWorkspaceId");
      LocalStorageService.removeItem("pendingTab");

      SessionService.clear();
   }
};

export default AuthService;
